<!--
This is a small (badge) version of On-Time performance.
More detailed, full version can be found in "./_Deprecated/components/FlightOTPRating"
-->

<template>
  <div style="position:relative">
    <div v-if="loading" class="">
      <b-skeleton :animated="animated"></b-skeleton>
      <b-skeleton :animated="animated"></b-skeleton>
      <b-skeleton :animated="animated"></b-skeleton>
    </div>
    <div v-else-if="error" class="">
      <b-message  type="is-danger" aria-close-label="Close message">
        <div class="is-size-7">
        There was an error loading On-Time Performance data.
        </div>
      </b-message>
    </div>
    <div v-else>
      <div v-if="!otpRatings.length" class="">
        <b-message  type="is-warning" aria-close-label="Close message">
          <div class="is-size-7">
          No On-Time Performance data is available for this flight.
          </div>
        </b-message>
      </div>
      <div v-else>

        <div class="has-text-centered is-centered">
          <div class="has-text-grey-dark is-size-7 is-flex is-justify-content-center">
            <strong>On-Time Performance</strong>
          </div>
          <div v-if="otpRatings[0].allStars" v-html="$options.filters.formatOTPRating(otpRatings[0].allStars)" class="has-text-centered is-centered mb-1 is-size-6"></div>
          <div v-else class="has-text-centered is-centered plan-item is-size-7 p-2">Rating Not Found</div>

          <p class="is-size-7">
            On-Time: <b>{{ otpRatings[0].ontimePercent | formatPercentage }}</b> <br> Avg Delay: <b>{{ otpRatings[0].delayMean }} min </b>
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: "FlightOTPRating",
  props: {
    airlineCode: String,
    flightNumber: String,
    departureAirport: String,
    preview: Boolean,
    journeyIndex: Number,
  },
  data: function () {
    return {
      loading: true,
      error: false,
      otpRatings: [],
      selectedBox: '',
      animated: true,
    };
  },
  methods:{
    getOTPPerformance() {
      //validate props first
      this.$helpers.validateProp(this.flightNumber);
      this.$helpers.validateProp(this.airlineCode);
      this.$helpers.validateProp(this.departureAirport);

      let body = {
        airlineCode: this.airlineCode,
        flightNumber: this.flightNumber,
        departureAirport: this.departureAirport,
      }

      if(this.flightsInfo.flightsInfo.length > 0){
        const found = this.flightsInfo.flightsInfo.find(element => element.flightNumber === this.flightNumber);
        if(found){
          this.otpRatings = found.ratings;
          this.loading = false;
        }
        else{
          this.callAPI('resources/flight-ratings', body);
        }
      }
      else{
        this.callAPI('resources/flight-ratings', body);
      }
    },
    callAPI(url, body){
      this.$app.huddleLabsServerCall(url, body).then(result => {
        // // console.log(`result of ${url}: `,  result.ratings);
        this.loading = false;
        this.otpRatings = result.ratings;
        this.error = result.error;

        let newFlightInfo = {
          'flightNumber': body.flightNumber,
          'ratings': result.ratings,
        }
        this.$store.dispatch('flightsInfo/addToFlightsInfo', newFlightInfo);
      });
    },
  },
  computed:{
    ...mapState(['flightsInfo']),
  },
  mounted() {
    this.getOTPPerformance();
  },
}
</script>

<style scoped>

</style>